import React from 'react';
import { Input } from 'antd';
import './CustomSearchInput.css';
import { useTranslation } from 'react-i18next';

const { Search } = Input;

const CustomSearchInput = ({ onSearch }) => {
	const { t } = useTranslation();

	return (
		<Search
			className='custom-search-input'
			placeholder={`${t('Search here')}...`}
			onSearch={onSearch}
			enterButton
		/>
	);
};

export default CustomSearchInput;
